export const fonts = {
    size: {
        small: '14px',
        medium: '16px',
        large: '18px',
        x_large: '20px',
        jumbo: '22px'
    },
    family: {
        main: 'Nunito Sans , sans-serif'
    },
    paragraph_line_height: '20'
}